import Vue from "vue";
import store from '../store/index'
import VueRouter from "vue-router";
import Inicio from "../components/Inicio";
import Login from "../components/Login";
import Registro from "../components/Registro";
import Recupero from "../components/Recupero";
import Reset from "../components/Reset";
import Index from "../components/Index";
import Cita from "../components/modulos/Cita";
import Roles from "../components/modulos/Roles";
import Usuarios from "../components/modulos/Usuarios";
import Configuracion from "../components/modulos/Configuracion";
import Historial from "../components/modulos/Historial";
import Vehiculos from "../components/modulos/Vehiculos";
import Planificacion from "../components/modulos/Planificacion";
import Cuenta from "../components/modulos/Cuenta";
import Publicidad from "../components/modulos/Publicidad";
import Contacto from "../components/modulos/Contacto";
import Bienvenido from "../components/modulos/Bienvenido";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "Inicio",
    component: Inicio,
    children: [{
        path: "Login",
        name: "Login",
        component: Login
      },
      {
        path: "Registro",
        name: "Registro",
        component: Registro
      },
      {
        path: "Recupero",
        name: "Recupero",
        component: Recupero
      }, {
        path: "Reset/:id",
        name: "Reset",
        component: Reset
      }
    ]
  },
  {
    path: "/Index",
    // name: "Index",
    component: Index,
    children: [{
        path: "",
        name: "Index",
        component: Bienvenido
      },
      {
        path: "Roles",
        name: "Roles",
        component: Roles
      }, {
        path: "Usuarios",
        name: "Usuarios",
        component: Usuarios
      }, {
        path: "Cuenta",
        name: "Cuenta",
        component: Cuenta
      }, {
        path: "Configuracion",
        name: "Configuracion",
        component: Configuracion
      }, {
        path: "Vehiculos",
        name: "Vehiculos",
        component: Vehiculos
      }, {
        path: "Cita",
        name: "Cita",
        component: Cita
      }, {
        path: "Historial",
        name: "Historial",
        component: Historial
      }, {
        path: "Planificacion",
        name: "Planificacion",
        component: Planificacion
      }, {
        path: "Publicidad",
        name: "Publicidad",
        component: Publicidad
      }, {
        path: "Contacto",
        name: "Contacto",
        component: Contacto
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH + "/",
  routes
});

const validarToken = async () => {
  const token = store.getters.getToken;
  if (!token) {
    return false;
  } else {
    return true;
  }
};

router.beforeEach(async (to, from, next) => {
  if (store.getters.getTokenValidado) {
    store.commit('setTokenValidado', false);
    next();
    return;
  }

  const autenticado = await validarToken();

  store.commit('setTokenValidado', true);

  if (!autenticado) {
    if (to.name != 'Login' && to.name != 'Registro' && to.name != 'Recupero' && to.name != 'Reset') {
      next({
        name: 'Login'
      });
    } else {
      next();
    }
  } else {
    switch (to.name) {
      case 'Inicio':
      case 'Login':
      case 'Registro':
      case 'Recupero':
      case 'Reset':
        next({
          name: 'Index'
        });
        break;
      default:
        next();
        break;
    }
  }
});

export default router;
